import { immerable, produce } from 'immer';

export enum LanguagePreference {
	Browser = 'browser',
	Fr = 'fr',
	En = 'en',
}

export type ViewMode = 'CARD' | 'LIST';

interface IPreference {
	sharedElemsViewMode: ViewMode;
}

const entityDefaults: IPreference = {
	sharedElemsViewMode: 'CARD',
};

export class UserPreference implements IPreference {
	private [immerable] = true;
	public sharedElemsViewMode = entityDefaults.sharedElemsViewMode;

	public static build(params: Partial<IPreference> = {}): UserPreference {
		const instance = new UserPreference();
		instance.sharedElemsViewMode =
			params.sharedElemsViewMode ?? entityDefaults.sharedElemsViewMode;

		return instance;
	}

	public setViewMode(val: ViewMode): UserPreference {
		return produce(this, (draft: UserPreference) => {
			draft.sharedElemsViewMode = val;
		});
	}
}
